export const birthdays = {
  title: "Cumpleaños en Gándara",
  subtitle: "Celebra el cumpleaños de tu hijo/a en nuestro espacio natural con actividades únicas y divertidas",
  courseYear: "Curso 2025-2026",
  
  gallery: {
    title: "Momentos de cumpleaños en Gándara",
    caption: "Un espacio especial para celebrar rodeados de naturaleza",
    images: [
      {
        src: "/lovable-uploads/patio-recetas-flores.jpg",
        alt: "Niños disfrutando en espacios naturales de Gándara"
      },
      {
        src: "/lovable-uploads/corro-plaza-piedra.png",
        alt: "Actividades al aire libre para cumpleaños"
      },
      {
        src: "/lovable-uploads/patio-rampa-pales.png",
        alt: "Espacios preparados para celebraciones"
      }
    ]
  },
  
  generalInfo: {
    title: "Información General",
    availabilityLabel: "Disponibilidad",
    availability: "Viernes por la tarde, Sábados y Domingos",
    durationLabel: "Duración",
    duration: "3-4 horas",
    description: "Ofrecemos un espacio único para celebrar cumpleaños infantiles en un entorno natural y respetuoso. Nuestras celebraciones están diseñadas para que los niños y niñas disfruten de una experiencia memorable rodeados de naturaleza, con actividades educativas y lúdicas que fomentan la creatividad y el juego libre."
  },
  
  plans: {
    title: "Planes Disponibles",
    priceNote: "hasta 15 niños/as",
    aTuAire: {
      name: "A tu Aire",
      description: "Espacio propio para tu celebración",
      features: [
        "Uso de nuestras instalaciones",
        "Acceso a zonas naturales",
        "Sin acompañamiento educativo"
      ],
      priceSmall: "120€",
      priceLarge: "180€"
    },
    acompanada: {
      name: "Acompañada",
      description: "Con animador/a profesional",
      features: [
        "Todo lo incluido en 'A tu Aire'",
        "Animador/a educativo/a",
        "1 taller dirigido a elegir"
      ],
      priceSmall: "250€",
      priceLarge: "400€"
    },
    experienciaCompleta: {
      name: "Experiencia Completa",
      description: "La celebración más especial",
      badge: "Recomendado",
      features: [
        "Todo lo incluido en 'Acompañada'",
        "2 talleres dirigidos a elegir",
        "Decoración temática",
        "Zona de merienda preparada"
      ],
      priceSmall: "400€",
      priceLarge: "500€"
    }
  },
  
  pricingTable: {
    title: "Tabla de Precios",
    headers: {
      plan: "Plan",
      small: "Hasta 15 niños/as",
      large: "16-30 niños/as"
    }
  },
  
  workshops: {
    title: "Talleres Disponibles",
    items: [
      "Rincones de juego",
      "Taller de arte",
      "Pintacaras",
      "Burbujas gigantes",
      "Cocina creativa",
      "Sensorial",
      "Pulseras",
      "DIY (Hazlo tú mismo)"
    ]
  },
  
  extras: {
    title: "Extras Disponibles",
    items: [
      { name: "Mini-Discoteca", price: "50€" },
      { name: "Merienda para adultos", price: "6€/persona" },
      { name: "Limpieza adicional", price: "30€" },
      { name: "Tarta de cumpleaños", price: "40€" },
      { name: "Taller adicional", price: "50€" }
    ]
  },
  
  booking: {
    title: "Proceso de Reserva",
    deposit: "Fianza",
    depositDescription: "Se requiere una fianza de 50€ que se descuenta del precio final de la celebración.",
    cancellation: "Política de Cancelación",
    cancellationDescription: "Las cancelaciones deben realizarse con al menos 1 semana de antelación para reembolso completo de la fianza."
  },
  
  form: {
    title: "Solicitud de Reserva",
    contactSection: "Datos de Contacto",
    birthdaySection: "Datos del Cumpleaños",
    preferencesSection: "Preferencias",
    extrasSection: "Extras (Opcional)",
    
    fields: {
      parentName: "Nombre del padre/madre",
      email: "Email",
      phone: "Teléfono",
      childName: "Nombre del niño/a",
      childAge: "Edad del niño/a",
      numberOfChildren: "Número de niños/as invitados",
      preferredDate: "Fecha preferida",
      alternativeDate: "Fecha alternativa (opcional)",
      selectedPlan: "Plan seleccionado",
      preferredWorkshops: "Talleres preferidos (máximo 2)",
      adultSnacksCount: "Número de adultos",
      comments: "Comentarios adicionales",
      acceptTerms: "Acepto los términos y condiciones"
    },
    
    placeholders: {
      parentName: "María García",
      email: "maria@example.com",
      phone: "+34 600 123 456",
      childName: "Nombre del cumpleañero/a",
      comments: "Preferencias, necesidades especiales... Si algún niño o niña tiene alergias, indícanos solo cuáles y cuántos, sin nombres."
    },
    
    submit: "Enviar solicitud de reserva",
    submitting: "Enviando...",
    success: "¡Solicitud enviada con éxito! Nos pondremos en contacto contigo pronto.",
    error: "Error al enviar la solicitud. Por favor, inténtalo de nuevo."
  },
  
  contact: {
    title: "¿Tienes preguntas?",
    description: "Contacta con nosotros para más información sobre disponibilidad, precios y opciones de personalización.",
    emailButton: "Contactar por email"
  }
};
